export default __webpack_public_path__ + "static/media/migration_evaluator.f1a17c7d.PNG";